import React, { useEffect, useState } from 'react';
import { formatSeoApiError, listBaggageRules } from '../../../utils/adminSeo';

export default function SeoBaggageScreen() {
  const [rules, setRules] = useState([]);
  const [err, setErr] = useState('');
  useEffect(() => {
    setErr('');
    listBaggageRules()
      .then((r) => setRules(r.rules || []))
      .catch((e) => setErr(formatSeoApiError(e)));
  }, []);
  return (
    <div className="space-y-4">
      <h2 className="text-xl font-semibold text-[#1B375B]">Baggage Rules</h2>
      {err && <p className="text-red-600 text-sm">{err}</p>}
      <div className="bg-white border rounded overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-gray-50">
            <tr>
              <th className="p-2">Airline</th>
              <th className="p-2">Cabin</th>
              <th className="p-2">Check-in</th>
            </tr>
          </thead>
          <tbody>
            {rules.map((r) => (
              <tr key={r.id} className="border-t">
                <td className="p-2">{r.airline_iata}</td>
                <td className="p-2">{r.cabin_kg || '—'}</td>
                <td className="p-2">{r.checkin_kg || '—'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
